import IndexDetails from '../components/index'

export default {
  IndexDetails
}



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/components/upcoming/resources/components.js